"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var declarations_1 = require("./declarations");
var utils_1 = require("./utils");
var Hermes = /** @class */ (function () {
    function Hermes(options) {
        var _this = this;
        this.handler = function () { };
        this.listening = true;
        this.binded = false;
        this.prevTouchPosition = { x: 0, y: 0 };
        this.prevTouchTime = 0;
        this.speed = { x: 0, y: 0 };
        this.lastScrollPosition = { x: 0, y: 0 };
        this.wheel = function (event) {
            var customEvent = {
                type: Hermes.EVENTS.WHEEL,
                delta: utils_1.normalizeWheelDelta(event),
                originalEvent: event,
            };
            _this.callHandler(customEvent);
        };
        this.scroll = function (event) {
            var e = _this.options.container;
            var w = _this.options.container;
            var delta = {
                x: (w.pageXOffset || e.scrollLeft || 0) - _this.lastScrollPosition.x,
                y: (w.pageYOffset || e.scrollTop || 0) - _this.lastScrollPosition.y,
            };
            _this.lastScrollPosition = {
                x: (w.pageXOffset || e.scrollLeft || 0),
                y: (w.pageYOffset || e.scrollTop || 0),
            };
            var customEvent = {
                type: Hermes.EVENTS.SCROLL,
                delta: delta,
                originalEvent: event,
            };
            _this.callHandler(customEvent);
        };
        this.keydownAll = function (event) {
            var customEvent = {
                type: Hermes.EVENTS.KEYS,
                delta: utils_1.normalizeKeyDelta(event.keyCode),
                originalEvent: event,
            };
            _this.callHandler(customEvent);
        };
        this.keydownSpacebar = function (event) {
            var customEvent = {
                type: Hermes.EVENTS.SPACEBAR,
                delta: utils_1.normalizeKeyDelta(event.keyCode),
                originalEvent: event,
            };
            _this.callHandler(customEvent);
        };
        this.keydownArrows = function (event) {
            var customEvent = {
                type: Hermes.EVENTS.ARROWS,
                delta: utils_1.normalizeKeyDelta(event.keyCode),
                originalEvent: event,
            };
            _this.callHandler(customEvent);
        };
        this.touchStart = function (event) {
            _this.options.container.addEventListener('touchmove', _this.touchMove);
            _this.prevTouchPosition = {
                x: event.touches[0].clientX,
                y: event.touches[0].clientY,
            };
        };
        this.touchMove = function (event) {
            var delta = {
                x: -(event.touches[0].clientX - _this.prevTouchPosition.x) * _this.options.touchMultiplier,
                y: -(event.touches[0].clientY - _this.prevTouchPosition.y) * _this.options.touchMultiplier,
            };
            _this.prevTouchPosition = {
                x: event.touches[0].clientX,
                y: event.touches[0].clientY,
            };
            var customEvent = {
                type: Hermes.EVENTS.TOUCH,
                delta: delta,
                originalEvent: event,
            };
            // Calculate touch speed
            var now = performance.now();
            var deltaT = now - _this.prevTouchTime;
            var speed = {
                x: delta.x / deltaT * 16,
                y: delta.y / deltaT * 16,
            };
            _this.speed = {
                x: speed.x * 0.9 + _this.speed.x * 0.1,
                y: speed.y * 0.9 + _this.speed.y * 0.1,
            };
            _this.prevTouchTime = now;
            _this.callHandler(customEvent);
        };
        this.touchEnd = function (event) {
            var customEvent = {
                type: Hermes.EVENTS.TOUCH,
                delta: _this.speed,
                originalEvent: event,
            };
            _this.callHandler(customEvent);
            _this.options.container.removeEventListener('touchmove', _this.touchMove);
        };
        this.callHandler = function (event) {
            if (_this.listening) {
                _this.handler(event);
                if (_this.options.emitGlobal) {
                    var eventInit = {};
                    eventInit.detail = event;
                    var customEvent = new CustomEvent("hermes-" + event.type, eventInit);
                    window.dispatchEvent(customEvent);
                }
            }
        };
        var defaults = {
            mode: Hermes.MODE.VIRTUAL,
            events: [
                Hermes.EVENTS.WHEEL,
                Hermes.EVENTS.TOUCH,
                Hermes.EVENTS.KEYS,
            ],
            container: document.querySelector('.hermes-container'),
            hook: document.querySelector('.hermes-hook'),
            passive: true,
            emitGlobal: false,
            touchClass: '.prevent-touch',
            touchMultiplier: 2,
        };
        this.options = __assign({}, defaults, options);
        if ((options.mode === Hermes.MODE.VIRTUAL || options.mode === Hermes.MODE.NATIVE)
            && typeof options.container === 'undefined') {
            throw new Error('Container cannot be undefined');
        }
        if (options.mode === Hermes.MODE.FAKE && typeof options.hook === 'undefined') {
            throw new Error('Hook cannot be undefined');
        }
    }
    Hermes.prototype.bind = function () {
        var _this = this;
        this.binded = true;
        if (this.options.mode === Hermes.MODE.VIRTUAL) {
            this.options.events.forEach(function (event) {
                switch (true) {
                    case event === 'wheel':
                        _this.options.container.addEventListener('wheel', _this.wheel, { passive: _this.options.passive });
                        _this.options.container.addEventListener('mousewheel', _this.wheel, { passive: _this.options.passive });
                        break;
                    case event === 'touch':
                        _this.options.container.addEventListener('touchstart', _this.touchStart, { passive: _this.options.passive });
                        _this.options.container.addEventListener('touchend', _this.touchEnd, { passive: _this.options.passive });
                        break;
                    case event === 'keys':
                        _this.options.container.addEventListener('keydown', _this.keydownAll);
                        break;
                    case event === 'spacebar' && _this.options.events.indexOf(Hermes.EVENTS.KEYS) < 0:
                        _this.options.container.addEventListener('keydown', _this.keydownSpacebar);
                        break;
                    case event === 'arrows' && _this.options.events.indexOf(Hermes.EVENTS.KEYS) < 0:
                        _this.options.container.addEventListener('keydown', _this.keydownArrows);
                        break;
                    default:
                        console.warn("'" + event + "' is not recognized");
                }
            });
        }
        else if (this.options.mode === Hermes.MODE.NATIVE) {
            this.options.container.addEventListener('scroll', this.scroll, { passive: this.options.passive });
            var e = this.options.container;
            var w = this.options.container;
            this.lastScrollPosition = {
                x: (w.pageXOffset || e.scrollLeft || 0),
                y: (w.pageYOffset || e.scrollTop || 0)
            };
        }
        else if (this.options.mode === Hermes.MODE.FAKE) {
            this.options.hook.addEventListener('scroll', this.scroll, { passive: this.options.passive });
        }
        else {
            console.warn("'" + this.options.mode + "' is not a supported mode");
        }
    };
    Hermes.prototype.unbind = function () {
        this.options.container.removeEventListener('wheel', this.wheel);
        this.options.container.removeEventListener('mousewheel', this.wheel);
        this.options.container.removeEventListener('touchstart', this.touchStart);
        this.options.container.removeEventListener('touchend', this.touchEnd);
        this.options.container.removeEventListener('touchmove', this.touchMove);
        this.options.container.removeEventListener('keydown', this.keydownAll);
        this.options.container.removeEventListener('keydown', this.keydownSpacebar);
        this.options.container.removeEventListener('keydown', this.keydownArrows);
        if (this.options.mode === Hermes.MODE.NATIVE) {
            this.options.container.removeEventListener('scroll', this.scroll);
        }
        if (this.options.mode === Hermes.MODE.FAKE) {
            this.options.hook.removeEventListener('scroll', this.scroll);
        }
        this.binded = false;
    };
    Hermes.prototype.on = function (handler) {
        if (this.binded)
            throw new Error('A handler is already binded');
        this.handler = handler;
        this.unbind();
        this.bind();
    };
    Hermes.prototype.off = function () {
        this.handler = function () { };
        this.unbind();
    };
    Hermes.prototype.destroy = function () {
        this.off();
    };
    Object.defineProperty(Hermes.prototype, "listen", {
        set: function (listening) {
            this.listening = listening;
        },
        enumerable: true,
        configurable: true
    });
    Hermes.MODE = declarations_1.MODE;
    Hermes.EVENTS = declarations_1.EVENTS;
    Hermes.KEYCODE = declarations_1.KEYCODE;
    return Hermes;
}());
exports.default = Hermes;
